/**
 * useSettingsListItems
 *
 * Returns the four server-driven settings categories (privacy / content /
 * payment / notifications) shown on `UserSettingsPage`. Theme and language
 * are now top-bar entries and no longer appear here.
 *
 * Both `UserSettingsPage` (renders the list) and `SettingsCategoryPage`
 * (looks up a category's title/icon by enum value) consume this hook.
 */

import { useMemo } from 'react';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { UserSettingCategory } from '@/domain/enums/settings/userSettingCategory';
import type { SettingsListItem } from '@/domain/entities/userSettings/settingsCategoryInfo';

export const useSettingsListItems = (): SettingsListItem[] => {
  const { l10n } = useLocale();

  return useMemo(() => {
    const settingsLabels = l10n.settings;

    return [
      {
        category: UserSettingCategory.privacy,
        title: settingsLabels.privacy,
        description: settingsLabels.privacyDescription,
        iconPath: '/assets/images/privacy.png',
      },
      {
        category: UserSettingCategory.content,
        title: settingsLabels.content,
        description: settingsLabels.contentDescription,
        iconPath: '/assets/images/video_cam.png',
      },
      {
        category: UserSettingCategory.payment,
        title: settingsLabels.payment,
        description: settingsLabels.paymentDescription,
        iconPath: '/assets/images/wallet.png',
      },
      {
        category: UserSettingCategory.notifications,
        title: settingsLabels.notifications,
        description: settingsLabels.notificationsDescription,
        iconPath: '/assets/images/notification.png',
      },
    ];
  }, [l10n]);
};
